<template>
  <div class="party-wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'party'
};
</script>
